export default __webpack_public_path__ + "33d61026d26b30983076d2f69a66ad26.png";